import React, { useEffect, useState } from "react";
import { Wrapper } from "../components/Wrapper";
import { PageTitle } from "../components/PageTitle";
import { CustomTable } from "../components/CustomTable";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { Notification } from "../utils/Notification";
import { useMutation, useQuery } from "@apollo/client";
import { GET_DICTIONARIES } from "../graphql/Queries/Dictionaries";
import {
  ADD_DICTIONARY,
  DELETE_DICTIONARY,
} from "../graphql/Mutations/DictionaryMutation";
import { Preload } from "../components/Preload";

export const Dictionaries = ({ url }) => {
  const [items, setItems] = useState([]);
  const navigator = useNavigate();
  const { loading, error, data } = useQuery(GET_DICTIONARIES, {
    fetchPolicy: "no-cache",
  });
  const [deleteDictionary] = useMutation(DELETE_DICTIONARY);

  const remove = (id) => {
    deleteDictionary({
      variables: {
        id: Number(id),
      },
    })
      .then((response) => {
        setItems(response.data.deleteDictionary);
      })
      .catch((error) => {
        Notification(error);
      });
  };

  const edit = (id) => {
    navigator(`${url}/form?id=${id}`);
  };

  useEffect(() => {
    if (data) {
      setItems(data.dictionaries);
    }
  }, [data]);

  if (!data) {
    return <Preload />;
  }

  return (
    <Wrapper>
      <PageTitle title={"Справочники"} />
      <div className="row">
        <div className="col-md-12">
          <div className="card">
            <div className="card-body">
              <CustomTable
                data={items}
                columns={[
                  { key: "id", label: "ID" },
                  { key: "name", label: "Название" },
                ]}
                search={true}
                sort={true}
                pagination={{
                  limit: 10,
                }}
                actions={[
                  {
                    slug: `${url}/form`,
                    icon: "fe-plus",
                    name: "Создать",
                  },
                ]}
                onClick={(id) => edit(id)}
                onDelete={(id) => remove(id)}
              />
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
};
